define('models/IngredientCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'models/IngredientModel'], function (_, ObjectCollection, LocalStorage, IngredientModel)
{
    //
    // Collection Currency
    //
    var IngredientCollectionPrototype = {

        name: 'IngredientCollection',
        route: 'apiIngredientCollection',
        model: IngredientModel,
        initialize: function ()
        {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);
        
        }
    };

    var IngredientCollection = ObjectCollection.extend(LocalStorage).extend(IngredientCollectionPrototype);

    return IngredientCollection;
});
